// TODO: Handle arrow keys navigation in mobile. Low priority
<script>
export default {
	name: 'BrandMonthYearFilter',
	inheritAttrs: false,
};
</script>

<script setup>
import dayjs from 'dayjs';
import Dropdown from '~/components/form/Dropdown.vue';
import { isMobileViewport } from '~/logic/composables/breakpoints.js';
import OverlayBtmSticky from '~/components/OverlayBtmSticky.vue';
import CTAButton from '~/aem-components/CTAButton.vue';
import { useIsRTL } from '~/logic/helpers/is-rtl.js';

const props = defineProps({
	yearList: { type: Array, default: () => [] },
	monthList: { type: Array, default: () => [] },
	allLabel: { type: String, default: '' },
	resetLabel: { type: String, default: '' },
	applyLabel: { type: String, default: '' },
	filterByLabel: { type: String, default: '' },
	monthLabel: { type: String, default: '' },
	yearLabel: { type: String, default: '' },
	yearDefaultValue: { type: String, default: '' },
	monthDefaultValue: { type: String, default: '' },
	brandDefaultValue: { type: String, default: '' },
	hideMonth: { type: Boolean, default: false },
	enableBrandsDropdown: { type: Boolean, default: false },
	brandsLabel: { type: String, default: '' },
	brandsTags: { type: Array, default: () => [] },
});

const emit = defineEmits([
	'update:filterQuery',
]);

const showFilterOverlay = ref(false);
const yearSelected = ref(props.yearDefaultValue);
const monthSelected = ref(props.monthDefaultValue);
const brandSelected = ref(props.brandDefaultValue);

const hasActiveFilter = computed(() => {
	if (filterOption.value.year == 'all' && filterOption.value.month == 'all' && filterOption.value.brand == 'all') {
		return false;
	}
	return true;
});

const handleMobileFilterIconClick = () => {
	if (isMobileViewport.value) {
		showFilterOverlay.value = true;
	}
};

const handleFilterReset = () => {
	yearSelected.value = 'all';
	monthSelected.value = 'all';
	brandSelected.value = 'all';
	emit('update:filterQuery', filterOption.value);
};

const handleMonthFilter = (value) => {
	monthSelected.value = value;
	if (!isMobileViewport.value) {
		emit('update:filterQuery', filterOption.value);
	}
};

const handleYearFilter = (value) => {
	yearSelected.value = value;
	if (!isMobileViewport.value) {
		emit('update:filterQuery', filterOption.value);
	}
};

const handleBrandFilter = (value) => {
	brandSelected.value = value;
	if (!isMobileViewport.value) {
		emit('update:filterQuery', filterOption.value);
	}
};

const submitFilter = () => {
	emit('update:filterQuery', filterOption.value);
	showFilterOverlay.value = false;
};

const filterOption = computed(() => {
	return {
		year: yearSelected.value,
		month: monthSelected.value,
		brand: brandSelected.value,
	};
});


const defaultYearList = computed(() => {
	return [
		{
			label: props.allLabel,
			value: 'all',
		},
		...props.yearList.map((item) => {
			return {
				label: item,
				value: item,
			};
		}),
	];
	
});

const setMonthList = computed(() => {
	return [
		{
			month: props.allLabel,
			monthShort: props.allLabel,
			value: 'all',
		},
		...props.monthList.map((data) => {
			return {
				month: dayjs().set('month', (+data - 1)).format('MMMM'),
				monthShort: dayjs().set('month', (+data - 1)).format('MMM'),
				value: dayjs().set('month', (+data - 1)).format('MM'),
			};
		}),
	];
	
});

const defaultMonthList = computed(() => {
	if (isMobileViewport.value) {
		return setMonthList.value.map((month) => {
			return {
				label: month.monthShort,
				value: month.value,
			};
		});
	}
	return setMonthList.value.map((month) => {
		return {
			label: month.month,
			value: month.value,
		};
	});
});

const defaultBrandList = computed(() => {
	return [
		{
			label: props.allLabel,
			value: 'all',
		},
		...props.brandsTags.map((brand) => {
			return {
				label: brand.title,
				value: brand.title,
			};
		}),
	];
});

const { isRTL } = useIsRTL();
</script>

<template>
<div class="BrandMonthYearFilter md:(flex items-center) w-full">
	<div
		v-if="!isMobileViewport"
		class="grid gap-6"
		:class="{
			'grid-cols-1': props.hideMonth && !props.enableBrandsDropdown,
			'grid-cols-2': (!props.hideMonth && props.enableBrandsDropdown) || (props.hideMonth && props.enableBrandsDropdown),
		}"
	>
		<div
			v-if="props.enableBrandsDropdown"
		>
			<Dropdown
				:options="defaultBrandList"
				:labelText="props.brandsLabel"
				:rootAttrs="{
					class: 'mt-0 h-13.5',
				}"
				name="brand"
				:defaultValue="props.brandDefaultValue"
				@change="handleBrandFilter"
			/>
		</div>
		<div
			class="grid grid-cols-2 gap-6"
		>
			<div
				:class="{
					'col-span-2': props.hideMonth,
				}"
			>
				<Dropdown
					:options="defaultYearList"
					:labelText="props.yearLabel"
					:rootAttrs="{
						class: 'mt-0 h-13.5',
					}"
					name="year"
					:defaultValue="props.yearDefaultValue"
					@change="handleYearFilter"
				/>
			</div>
			<div
				v-if="!props.hideMonth"
				class="w-full"
			>
				<Dropdown
					:options="defaultMonthList"
					:labelText="props.monthLabel"
					:rootAttrs="{
						class: 'mt-0 h-13.5',
					}"
					:defaultValue="props.monthDefaultValue"
					name="month"
					@change="handleMonthFilter"
				/>
			</div>
		</div>
	</div>
	<div v-else>
		<button
			type="button"
			class="hidden relative md:block"
		>
			<icon-fas-filter
				@click="handleMobileFilterIconClick"
			/>
			<span
				:class="{ 'hidden': !hasActiveFilter }"
				class="filter-icon-red-dot block"
			></span>
		</button>
		<OverlayBtmSticky
			:isVisible="showFilterOverlay && isMobileViewport"
			@update:is-visible="showFilterOverlay = $event"
		>
			<div class="sticky-btm-overlay-filter-container">
				
				<div class="flex flex-row item-center justify-between pb-6">
					<h5>{{ props.filterByLabel }}</h5>
					<button
						type="button"
						class="sticky-btm-overlay-reset-btn"
						:disabled="!hasActiveFilter"
						@click="handleFilterReset"
					>
						<IconFarArrowRotateLeft v-if="isRTL" class="mr-3.25" />
						<IconFarArrowRotateRight v-else class="mr-3.25" />
						<span>{{ props.resetLabel }}</span>
					</button>
				</div>

				<div v-if="props.enableBrandsDropdown" class="mb-6">
					<h6 class="pb-4">{{ props.brandsLabel }}</h6>
					<div
						class="w-full grid grid-cols-1 gap-x-1 gap-y-1 content-center my-auto"
					>
						<div
							v-for="(brand) in defaultBrandList"
							:key="brand"
							class="flex"
						>
							<button
								type="button"
								class="brand-single"
								:class="{
									'is-selected': brand.value == brandSelected,
									'is-pointed': brand.value == brand.value,
								}"
								:tabindex="year == year ? 0 : -1"
								:aria-label="year"
								@click="handleBrandFilter(brand.value)"
							>{{ brand.label }}</button>
						</div>
					</div>
				</div>

				<div class="mb-6">
					<h6 class="pb-4">{{ props.yearLabel }}</h6>
					<div
						class="w-full grid grid-cols-4 gap-x-1 gap-y-1 content-center my-auto"
					>
						<div
							v-for="(year) in defaultYearList"
							:key="year"
							class="flex"
						>
							<button
								type="button"
								class="year-single btn-generic-b w-full"
								:class="{
									'is-selected': year.value == yearSelected,
									'is-pointed': year.value == year.value,
								}"
								:tabindex="year.value == year.value ? 0 : -1"
								:aria-label="year.label"
								@click="handleYearFilter(year.value)"
							>{{ year.label }}</button>
						</div>
					</div>
				</div>

				<div v-if="!props.hideMonth">
					<h6 class="pb-4">{{ props.monthLabel }}</h6>
					<div
						class="w-full grid grid-cols-4 gap-x-1 gap-y-1 content-center my-auto"
					>
						<div
							v-for="(month) in defaultMonthList"
							:key="month"
							class="flex"
						>
							<button
								type="button"
								class="year-single btn-generic-b w-full"
								:class="{
									'is-selected': month.value == monthSelected,
									'is-pointed': month.value == month.value,
								}"
								:aria-label="month.label"
								@click="handleMonthFilter(month.value)"
							>{{ month.label }}</button>
						</div>
					</div>
				</div>

				<div class="mt-6 py-4 pl-3.5 border-solid border-t flex flex-row-reverse">
					<CTAButton
						containerClass="ml-6 flex-shrink w-auto"
						sizeType="small"
						styleType="primary"
						:ctaText="props.applyLabel"
						:disabled="!hasActiveFilter"
						@click="submitFilter"
					></CTAButton>
				</div>

			</div>
		</OverlayBtmSticky>
	</div>
</div>
</template>



<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.BrandMonthYearFilter {
	height: 54px;

	:deep(.multiselect-main) {
		@apply mt-0
	}
}
.sticky-btm-overlay-filter-container {
	background-color: var(--neutral-grey-ultralight);
	fill: var(--neutral-grey-extradark);
	color: var(--primary-black-base);
	@apply rounded-lg pt-10.25 px-6 mb-6;
}
.sticky-btm-overlay-reset-btn {
	display: flex;
	flex-direction: row;
	align-items: center;
	color: var(--primary-blue-base);
	fill: var(--primary-blue-base);

	&[disabled] {
		color: var(--neutral-grey-dark);
		fill: var(--neutral-grey-dark);
	}

	[dir="rtl"] & {
		flex-direction: row-reverse;
	}
}
.filter-icon-red-dot {
	position: absolute;
	right: 15%;
	background-color: var(--semantic-red-base);
	@apply rounded-full w-2 h-2 top-0;

	[dir="rtl"] & {
		right: auto;
		left: 15%;
	}
}
.year-single {
	color: var(--text-color);
	border-radius: 48px;
	position: relative;
	@apply py-3;
	
	&.is-selected {
		background-color: var(--primary-blue-base);
		color: white;
	}
	
	&[disabled] {
		color: var(--neutral-grey-dark);
		
		&.is-selected {
			background-color: var(--primary-blue-extralight);
		}
	}
}
.brand-single {
	text-align: left;
	width: 100%;
	border-radius: 8px;
	@apply py-3;

	&.is-selected {
		background-color: var(--primary-blue-base);
		color: white;
	}
	
	&[disabled] {
		color: var(--neutral-grey-dark);
		
		&.is-selected {
			background-color: var(--primary-blue-extralight);
		}
	}
}
</style>
